var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132px",
    height: "132px",
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C77F2BED-43A1-4D44-AE76-9EB9AB3286B7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MODAL-SIGN-UP",
    transform: "translate(-228.000000, -908.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(96.781250, 288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(131.218750, 620.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L132,0 L132,0 L132,132 L12,132 C5.372583,132 8.11624501e-16,126.627417 0,120 L0,12 C-8.11624501e-16,5.372583 5.372583,8.32286411e-15 12,0 Z",
    id: "Rectangle",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.975,45 C72.859375,45 76.475,43.0165289 78.628125,40.3719008 C80.578125,37.9752066 82,34.6280992 82,31.2809917 C82,30.8264463 81.959375,30.3719008 81.878125,30 C78.66875,30.1239669 74.809375,32.1900826 72.49375,34.9586777 C70.665625,37.0661157 69,40.3719008 69,43.7603306 C69,44.2561983 69.08125,44.7520661 69.121875,44.9173554 C69.325,44.9586777 69.65,45 69.975,45 Z M59.615625,96 C63.55625,96 65.303125,93.2757754 70.21875,93.2757754 C75.215625,93.2757754 76.3125,95.9161777 80.7,95.9161777 C85.00625,95.9161777 87.890625,91.8088852 90.6125,87.7854149 C93.659375,83.1751886 94.91875,78.6487846 95,78.4392288 C94.715625,78.3554065 86.46875,74.8767812 86.46875,65.1114837 C86.46875,56.6454317 92.96875,52.8315172 93.334375,52.5381391 C89.028125,46.1676446 82.4875,46 80.7,46 C75.865625,46 71.925,49.0176027 69.446875,49.0176027 C66.765625,49.0176027 63.23125,46.1676446 59.046875,46.1676446 C51.084375,46.1676446 43,52.9572506 43,65.782062 C43,73.7451802 46.00625,82.169321 49.703125,87.6177703 C52.871875,92.2279966 55.634375,96 59.615625,96 Z",
    id: "\\uF8FF",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.378542d9a9838d447ec6d50923cb858d.svg";
export { ForwardRef as ReactComponent };